import { render, staticRenderFns } from "./BrandFlowOverview.vue?vue&type=template&id=2cd3835d&scoped=true"
import script from "./BrandFlowOverview.vue?vue&type=script&lang=js"
export * from "./BrandFlowOverview.vue?vue&type=script&lang=js"
import style0 from "./BrandFlowOverview.vue?vue&type=style&index=0&id=2cd3835d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3835d",
  null
  
)

export default component.exports